import { FC, ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getEffectiveToken, isDeveloperSession } from 'src/Common/navigation/developerAccess';
import { getPostLoginHomePath } from 'src/Common/navigation/getPostLoginHomePath';

/**
 * Route gate for the developer-only modules (/developer/**).
 *
 * Wraps the group's layout element, so EVERY child route — including deep links typed
 * straight into the address bar and the /finance → /developer/billing redirects — passes
 * through it. A store user is sent to their own post-login home (never to a 403 page they
 * could bookmark), an anonymous visitor to /login, and a Developer session renders the
 * children unchanged.
 *
 * The decision is made synchronously from the session's effective token, so nothing
 * developer-only is ever painted first and hidden afterwards.
 */
const RequireDeveloper: FC<{ children: ReactNode }> = ({ children }) => {
  const location = useLocation();

  if (isDeveloperSession()) return <>{children}</>;

  if (!getEffectiveToken()) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <Navigate to={getPostLoginHomePath()} replace />;
};

export default RequireDeveloper;
